exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    height: 100vh;\n}\n\n.error-icon {\n    width: 50px;\n    height: 50px;\n    margin-bottom: 20px;\n    animation: rotate 2s linear infinite;\n    /* CSS animation */\n}\n\n.error-message {\n    font-size: 20px;\n    color: red;\n}\n\n@keyframes rotate {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}", ""]);

// exports
